import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as pdfjs from 'pdfjs-dist';
import Tesseract from 'tesseract.js';
import { Upload, Button, Spin, Typography, Card, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { getCurrentInstructions } from '../utils/conversation_config';

// Import Assets:
import RecordLogoWhite from '../assets/images/Record_Logo_White.png';


// Initialize PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const { Title, Text } = Typography;

const UploadPage: React.FC = () => {
  const [fileName, setFileName] = useState<string>('');
  const [resumeContent, setResumeContent] = useState<string | null>(null);
  const [instructions, setInstructions] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const extractPdfContent = async (file: File): Promise<string> => {
    const arrayBuffer = await file.arrayBuffer();
    const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;

    const textPromises = Array.from({ length: pdf.numPages }, (_, i) =>
      pdf.getPage(i + 1).then((page) =>
        page.getTextContent().then((textContent) =>
          textContent.items.map((item: any) => item.str).join(' ')
        )
      )
    );

    const pageTexts = await Promise.all(textPromises);
    return pageTexts.join('\n\n');
  };

  const extractImageContent = async (file: File): Promise<string> => {
    const imageUrl = URL.createObjectURL(file);
    const result = await Tesseract.recognize(imageUrl, 'eng');
    URL.revokeObjectURL(imageUrl); // Clean up
    return result.data.text;
  };

  const handleFileUpload = async (file: File) => {
    setIsLoading(true);
    setFileName(file.name);

    try {
      const content =
        file.type === 'application/pdf'
          ? await extractPdfContent(file)
          : file.type.startsWith('image/')
          ? await extractImageContent(file)
          : (() => {
              throw new Error('Unsupported file type. Please upload a PDF or image.');
            })();

      setResumeContent(content);
      const generatedInstructions = getCurrentInstructions(content);
      setInstructions(generatedInstructions);
      notification.success({ message: 'File uploaded successfully!' });
    } catch (error) {
      console.error('Error extracting content:', error);
      notification.error({ message: 'Failed to upload file. Please try again.' });
    } finally {
      setIsLoading(false);
    }

    return false;
  };



  console.log('resume content '+resumeContent)
  const handleContinue = () => {
    if (resumeContent && instructions) {
      navigate('/start', { state: { resumeContent, instructions } });
    }
  };

  return (
    <div className="upload-page" style={{ minHeight: '100vh', backgroundColor: '#f0f2f5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Card style={{ width: 500, textAlign: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.2)' }}>
        <div className=' flex justify-center items-center '>
        <img src={RecordLogoWhite} alt="Record.in Logo" style={{ marginBottom: 20, width: '150px' }} />
        </div>
       
        <Title level={2}>Upload Your Resume</Title>
        <Text type="secondary">Upload your PDF or image file to proceed with the interview.</Text>
        {
          !resumeContent ? <Upload beforeUpload={handleFileUpload} accept="application/pdf,image/*" showUploadList={false}>
          <Button icon={<UploadOutlined />} type="primary" style={{ marginTop: 20 }}>Upload Resume</Button>
        </Upload> :''
        }
        

        {isLoading && <Spin style={{ marginTop: 20 }} />}

        {resumeContent && (
          <div style={{ marginTop: 20 }}>
            <Text strong>File Name: {fileName}</Text>
            <br />
            <Button type="primary" onClick={handleContinue} style={{ marginTop: 10 }}>Continue to Interview</Button>
          </div>
        )}
      </Card>

      
    </div>
  );
};

export default UploadPage;